(function (cw, $, undefined) {
  $.extend(true, cw, {
    alert: {
      Alert: function (messageHtml, $target) {
        cw.alert.ShowAlert(messageHtml, cw.appEnum.alertLevel.warning, $target);
      },
      ShowAlert: function (messageHtml, alertLevel, $target, alertButtonHtml) {
        if ($target === null) {
          $target = $(".error-wrapper");
        }

        var msg = "";
        if (Object.prototype.toString.call(messageHtml) === "[object Array]") {
          msg = "<ul>";
          for (var i = 0; i < messageHtml.length; i++) {
            if (Object.prototype.toString.call(messageHtml) === "[object Array]") {
              if (typeof messageHtml[i].text !== "undefined") {
                msg += "<li>" + messageHtml[i].text + "</li>";
              } else {
                msg += "<li>" + messageHtml[i] + "</li>";
              }

              if (
                typeof messageHtml[i].$el !== "undefined" &&
                messageHtml[i].$el &&
                messageHtml[i].$el instanceof jQuery &&
                messageHtml[i].$el.length > 0
              ) {
                messageHtml[i].$el.closest(".form-group").addClass("has-error");
              }
            } else {
              msg += "<li>" + messageHtml[i] + "</li>";
            }
          }

          msg += "</ul>";
        } else if (Object.prototype.toString.call(messageHtml) === "[object Object]") {
          if (typeof messageHtml.text !== "undefined") {
            msg = "<ul><li>" + messageHtml.text + "</li></ul>";
          }

          if (typeof messageHtml.$el !== "undefined" && messageHtml.$el instanceof jQuery) {
            messageHtml.$el.closest(".form-group").addClass("has-error");
          }
        } else if (typeof messageHtml === "string") {
          msg = messageHtml;
        }

        if ($target.length > 0) {
          var alertClass = "";
          switch (alertLevel) {
            case cw.appEnum.alertLevel.success:
              alertClass = "alert-success";
              break;
            case cw.appEnum.alertLevel.info:
              alertClass = "alert-info";
              break;
            case cw.appEnum.alertLevel.warning:
              alertClass = "alert-warning";
              break;
            case cw.appEnum.alertLevel.danger:
              alertClass = "alert-danger";
              break;
            default:
              cw.utility.Debug("unknown alert type!");
          }

          if ($target.children().length > 0) {
            $target.empty();
          }

          $target
            .append(
              '<div class="alert ' +
                alertClass +
                ' alert-dismissible">' +
                (alertButtonHtml !== "undefined" && alertButtonHtml
                  ? alertButtonHtml
                  : '<button aria-hidden="true" data-dismiss="alert" class="close" type="button">×</button>') +
                msg +
                "</div>"
            )
            .show()
            .removeClass("hidden");
        } else {
          var regex = /(<([^>]+)>)/gi;
          var message = msg.replace(regex, "");

          alert(message);
        }
      },
      ClearAlert: function ($target) {
        if ($target === null) {
          $target = $(".error-wrapper");
        }

        if ($target.children().length > 0) {
          $target.empty();
          //.fadeOut();
        }

        $(".form-group.has-error").removeClass("has-error");
      },
    },
  });
})((window.cw = window.cw || {}), jQuery);
